import { AVATAR_SIZES, RETINA_MULTIPLIER } from '../Constants';
import { Size } from '../types/SharedPropTypes';

// @ts-expect-error module not typed
import MD5 from './MD5';

// @ts-expect-error - bender-url is not typed
import defaultContactImage from 'bender-url!avatar-components/images/default-avatar.png';

import envSuffix from './envSuffix';

export const getUnauthedHubSpotUserAvatarUrl = ({
  hubSpotUserEmail,
  size,
  dimension = AVATAR_SIZES.xl,
  // Remove this param when cleaned up from UserPreferencesUI/static/js/api/AvatarAPI.ts
  isUngatedForTrellisIcons: __isUngatedForTrellisIcons,
}: {
  hubSpotUserEmail: string;
  size?: Size;
  dimension?: number;
  isUngatedForTrellisIcons?: boolean;
}) => {
  const hashedEmailAddress = MD5((hubSpotUserEmail || '').toLowerCase());

  if (typeof hubSpotUserEmail === 'undefined') {
    return defaultContactImage;
  }

  let sizePx = dimension;
  if (size) {
    sizePx = size !== 'responsive' ? AVATAR_SIZES[size] : AVATAR_SIZES.xl;
  }

  const doubleDimensionForRetina = sizePx * RETINA_MULTIPLIER;

  // Returns a 1px transparent image for the default avatar so we can use the SVG in the fallback
  return `https://app.hubspot${envSuffix()}.com/userpreferences/v1/avatar/transparent-default/${hashedEmailAddress}?size=${doubleDimensionForRetina}`;
};
